import * as React from 'react';
export const SvgModel = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', fill: 'var(--iui-color-icon-muted, currentColor)', ...props },
        React.createElement("path", { d: 'M14 11.126L8 8.172V1.361l-.5-.246-.5.246v6.811l-6 2.954v.559l.565.278L7.5 9.041l5.935 2.922.565-.278z', opacity: 0.33 }),
        React.createElement("path", { d: 'M7.5 0L0 3.692v8.616L7.5 16l7.5-3.692V3.692zm5.935 4.037L7.5 6.959 1.565 4.037 7.5 1.115zM1 11.685v-6.81l6 2.953v6.811zm13 0L8 14.64V7.828l6-2.954z' })));
};
export default SvgModel;
